import * as React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BottomSheetProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
    className?: string;
}

export function BottomSheet({ open, onOpenChange, title, subtitle, children, footer, className }: BottomSheetProps) {
    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-fade-in" />
                <Dialog.Content
                    className={cn(
                        'fixed inset-x-0 bottom-0 z-50 flex max-h-[92vh] flex-col rounded-t-3xl bg-white shadow-2xl outline-none sm:inset-x-auto sm:bottom-auto sm:left-1/2 sm:top-1/2 sm:max-w-md sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-2xl data-[state=open]:animate-slide-up sm:data-[state=open]:animate-fade-in',
                        className,
                    )}
                >
                    {/* Drag handle (mobile) */}
                    <div className="flex justify-center pt-2 sm:hidden">
                        <div className="h-1.5 w-10 rounded-full bg-gray-300" />
                    </div>

                    {(title || subtitle) && (
                        <div className="flex items-start justify-between gap-3 px-5 pb-3 pt-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <div className="flex-1 min-w-0">
                                {title && <Dialog.Title className="text-base font-bold text-gray-900">{title}</Dialog.Title>}
                                {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
                            </div>
                            <Dialog.Close className="rounded-full p-1.5 text-gray-400 hover:bg-gray-100">
                                <X className="h-4 w-4" />
                            </Dialog.Close>
                        </div>
                    )}

                    <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>

                    {footer && (
                        <div className="px-5 pb-safe pt-3" style={{ borderTop: '1px solid #f3f4f6' }}>
                            <div className="pb-3">{footer}</div>
                        </div>
                    )}
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
}
